import { useActor } from '@xstate/react';
import { AccountView } from './AccountView';
import { AccountMachineActor } from '../../../machines/RedeemInvitation/AccountMachine';

export function AccountController({ actor }: { actor: AccountMachineActor }) {
  const [state, send] = useActor(actor);

  return <AccountView state={state} send={send} />;
}
